import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
  Container,
} from '@mui/material';
import { getLocationOn, Colors } from '../../../helpers/navigationHelpers';
import styles from './Notifications.module.css';

const Notifications = () => {
  const [locationOn, setLocationOn] = useState(false);
  const [muteAllChats, setMuteAllChats] = useState(false);
  const [muteAllNearBy, setMuteAllNearBy] = useState(false);
  const [dontNotifyFriendsWhenNearBy, setDontNotifyFriendsWhenNearBy] = useState(false);

  useEffect(() => {
    setLocationOn(getLocationOn());
  }, []);

  const primaryColor = locationOn ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;

  return (
    <Container maxWidth="md" className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h4" component="h1" gutterBottom>
          Notifications
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage your notification preferences
        </Typography>
      </Box>

      <Paper elevation={2} className={styles.section}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Subscribe to Topics
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Get notified about topics you're interested in
        </Typography>
        <Box className={styles.comingSoon}>
          <Typography variant="body1" color="text.secondary">
            Topic subscriptions coming soon...
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={2} className={styles.section}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Global Notifications
        </Typography>
        
        <Box className={styles.settingItem}>
          <FormControlLabel
            control={
              <Switch
                checked={muteAllChats}
                onChange={(e) => setMuteAllChats(e.target.checked)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: primaryColor,
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: primaryColor,
                  },
                }}
              />
            }
            label="Mute All Chats Notifications"
          />
        </Box>

        <Box className={styles.settingItem}>
          <FormControlLabel
            control={
              <Switch
                checked={muteAllNearBy}
                onChange={(e) => setMuteAllNearBy(e.target.checked)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: primaryColor,
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: primaryColor,
                  },
                }}
              />
            }
            label="Mute Friends Near By Notifications"
          />
        </Box>

        <Box className={styles.settingItem}>
          <FormControlLabel
            control={
              <Switch
                checked={dontNotifyFriendsWhenNearBy}
                onChange={(e) => setDontNotifyFriendsWhenNearBy(e.target.checked)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: primaryColor,
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: primaryColor,
                  },
                }}
              />
            }
            label="Don't Notify Friends When Near By"
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default Notifications;

















